import { render, staticRenderFns } from "./AutoPostBoostingAdSet.vue?vue&type=template&id=1ed70ee3&scoped=true&"
import script from "./AutoPostBoostingAdSet.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingAdSet.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingAdSet.vue?vue&type=style&index=0&id=1ed70ee3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed70ee3",
  null
  
)

export default component.exports